import React from 'react';
import { thStyle, tdStyle, selectStyle, timeSelectStyle, btnAkcijaStyle, sumaStyle } from './PlateStyles';
import { ispeglaVreme, izracunajSate, decimalToTime, formatirajDatumSRB } from './PlateUtils';

const PlateTable = ({ 
    tabelaDana, obrisaniDatumi, selektovaniRadnik, tabelaZakljucana, zakljucaniRedovi, 
    terenStatusi, terenskiDodaci, rucniStatusi, rucnaVremena, 
    setTerenStatusi, setTerenskiDodaci, setRucniStatusi, updateTime, 
    setDeleteModal, toggleZakljucajRed, setTabelaZakljucana 
}) => {
    let sumaUkupno = 0;
    let sumaRedovno = 0;
    let sumaPrekovremeno = 0;

    const rows = Object.keys(tabelaDana).sort().map(datum => {
        if (obrisaniDatumi[`${selektovaniRadnik}_${datum}`]) return null;
        
        const podaci = tabelaDana[datum];
        const isRedZakljucan = tabelaZakljucana || zakljucaniRedovi[datum];
        const naTerenu = terenStatusi[datum] || 'ne';
        
        const pVRaw = rucnaVremena[`${datum}_p`] || podaci.prijava;
        const oVRaw = rucnaVremena[`${datum}_o`] || podaci.odjava;
        const pV = ispeglaVreme(pVRaw, 'prijava');
        const oV = ispeglaVreme(oVRaw, 'odjava');
        
        // Funkcija izracunajSate sada prima naTerenu koji može biti 'ne', 'Srbija' ili 'Inostranstvo'
        const kalk = izracunajSate(pV, oV, naTerenu);
        
        sumaUkupno += kalk.ukupnoDec; 
        sumaRedovno += kalk.redovnoDec; 
        sumaPrekovremeno += kalk.prekovremenoDec;

        const [ph, pm] = pV.split(':'); 
        const [oh, om] = oV.split(':');
        const status = rucniStatusi[datum] || (kalk.imaSati ? 'Radni dan' : 'Nema zapisa');

        return (
            <tr key={datum} style={{backgroundColor: status === 'Radni dan' ? 'transparent' : '#1a1a2e', opacity: isRedZakljucan ? 0.8 : 1}}>
                <td style={tdStyle}>{podaci.dan}</td>
                <td style={tdStyle}>{formatirajDatumSRB(datum)}</td>
                <td style={tdStyle}>
                    <select 
                        disabled={isRedZakljucan} 
                        value={naTerenu} 
                        onChange={(e) => setTerenStatusi({...terenStatusi, [datum]: e.target.value})} 
                        style={selectStyle}
                    >
                        <option value="ne">ne</option>
                        <option value="Srbija">Srbija</option>
                        <option value="Inostranstvo">Inostranstvo</option>
                    </select>
                </td>
                <td style={tdStyle}>
                    <select disabled={isRedZakljucan} value={terenskiDodaci[datum] || 'ne'} onChange={(e) => setTerenskiDodaci({...terenskiDodaci, [datum]: e.target.value})} style={selectStyle}>
                        <option value="ne">ne</option><option value="da">da</option>
                    </select>
                </td>
                <td style={tdStyle}>
                    <select disabled={isRedZakljucan} value={status} onChange={(e) => setRucniStatusi({...rucniStatusi, [datum]: e.target.value})} style={selectStyle}>
                        <option value="Radni dan">Radni dan</option>
                        <option value="Bolovanje">Bolovanje</option>
                        <option value="Odmor">Odmor</option>
                        <option value="Praznik">Praznik</option>
                        <option value="Krsna slava">Krsna slava</option>
                        <option value="Neplaćeni dan">Neplaćeni dan</option>
                        <option value="Nema zapisa">Nema zapisa</option>
                    </select>
                </td>
                <td style={{...tdStyle, color: '#00ff00'}}>
                    <select disabled={isRedZakljucan} value={ph} onChange={(e) => updateTime(datum, 'p', 'h', e.target.value)} style={{...timeSelectStyle, color: '#00ff00'}}>
                        {Array.from({length: 24}, (_, i) => String(i).padStart(2, '0')).map(s => <option key={s} value={s}>{s}</option>)}
                    </select>:
                    <select disabled={isRedZakljucan} value={pm} onChange={(e) => updateTime(datum, 'p', 'm', e.target.value)} style={{...timeSelectStyle, color: '#00ff00'}}>
                        {Array.from({length: 12}, (_, i) => String(i * 5).padStart(2, '0')).map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                </td>
                <td style={{...tdStyle, color: '#ff4444'}}>
                    <select disabled={isRedZakljucan} value={oh} onChange={(e) => updateTime(datum, 'o', 'h', e.target.value)} style={{...timeSelectStyle, color: '#ff4444'}}>
                        {Array.from({length: 24}, (_, i) => String(i).padStart(2, '0')).map(s => <option key={s} value={s}>{s}</option>)}
                    </select>:
                    <select disabled={isRedZakljucan} value={om} onChange={(e) => updateTime(datum, 'o', 'm', e.target.value)} style={{...timeSelectStyle, color: '#ff4444'}}>
                        {Array.from({length: 12}, (_, i) => String(i * 5).padStart(2, '0')).map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                </td>
                <td style={tdStyle}>{kalk.ukupno}</td>
                <td style={tdStyle}>{kalk.redovno}</td>
                <td style={{...tdStyle, color: kalk.prekovremeno !== '00:00' ? '#ffcc00' : 'white'}}>{kalk.prekovremeno}</td>
                <td style={tdStyle}>
                    {!tabelaZakljucana && (
                        <>
                            <button onClick={() => setDeleteModal({ show: true, datum: datum })} style={{...btnAkcijaStyle, display: isRedZakljucan ? 'none' : 'inline-block'}}>Briši</button>
                            <button onClick={() => toggleZakljucajRed(datum)} style={{...btnAkcijaStyle, backgroundColor: zakljucaniRedovi[datum] ? '#ffcc00' : 'white'}}>
                                {zakljucaniRedovi[datum] ? 'Otključaj' : 'Zaključaj'}
                            </button>
                        </>
                    )}
                </td>
            </tr>
        );
    });

    return (
        <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
                <tr>
                    <th style={thStyle}>Dan</th>
                    <th style={thStyle}>Datum</th>
                    <th style={thStyle}>Izlazak na teren</th>
                    <th style={thStyle}>T. Dodatak</th>
                    <th style={thStyle}>Status</th>
                    <th style={thStyle}>Prijava</th>
                    <th style={thStyle}>Odjava</th>
                    <th style={thStyle}>Ukupno</th>
                    <th style={thStyle}>Redovno</th>
                    <th style={thStyle}>Prekovremeno</th>
                    <th style={thStyle}>Akcije</th>
                </tr>
            </thead>
            <tbody>{rows}</tbody>
            <tfoot>
                <tr>
                    <td colSpan="7" style={{...sumaStyle, textAlign: 'right', paddingRight: '20px', color: 'white'}}>UKUPNO:</td>
                    <td style={{...sumaStyle, color: 'white'}}>{decimalToTime(sumaUkupno)}</td>
                    <td style={{...sumaStyle, color: 'white'}}>{decimalToTime(sumaRedovno)}</td>
                    <td style={{...sumaStyle, color: '#ffcc00'}}>{decimalToTime(sumaPrekovremeno)}</td>
                    <td style={sumaStyle}>
                        <button onClick={() => setTabelaZakljucana(!tabelaZakljucana)} style={{...btnAkcijaStyle, backgroundColor: tabelaZakljucana ? '#ffcc00' : 'white', width: '100%'}}>
                            {tabelaZakljucana ? 'Otključaj sve' : 'Zaključaj tabelu'}
                        </button>
                    </td>
                </tr>
            </tfoot>
        </table>
    );
};
export default PlateTable;